module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"G-D8W8T4NVBT"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
